module.exports = __webpack_public_path__ + "img/svg/competition-card-hover.0905d38d6ff233b9b590e3bb4ab8b11d.svg";